var _mask, _mask2, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeKnife(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--knife_svg__a",
    height: 37,
    maskUnits: "userSpaceOnUse",
    width: 37,
    x: 6,
    y: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7h37v37H6z",
    fill: "#d9d9d9"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--knife_svg__b",
    height: 40,
    maskUnits: "userSpaceOnUse",
    width: 41,
    x: 5,
    y: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03 5h40v40h-40z",
    fill: "#d9d9d9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    fill: "#e3fb94",
    r: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--knife_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--knife_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.33 29.88l2.953 2.969-2.658 2.565c-.406.403-.923.586-1.476.586h-.037c-.554 0-1.07-.22-1.477-.623a2.08 2.08 0 01.037-2.968zm17.054-15.205a.771.771 0 00-.48-.623c-.258-.11-.553-.037-.775.146L19.55 28.415c-.148.147-.222.33-.222.513s.074.367.221.513l4.098 4.177c.147.147.332.22.516.22.222 0 .407-.11.517-.256l6.94-7.768c.627-.697 1.144-1.356 1.55-2.016a14.026 14.026 0 002.215-9.123z",
    fill: "#000"
  })))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--knife-b88404baee1a144d33866aab0d50de7f.svg";
export { SvgIconCircleLimeKnife as Component };